import { VDBText } from "@components/atoms";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTheme } from "styled-components/native";
import { canRequestProps } from "../types";
import styled from "styled-components/native";

const CanRequest = ({ ScreenText }: canRequestProps) => {
  const typography = useTypographyStore();
  const theme = useTheme();
  return (
    <OverLay>
      <VDBText type={typography["H3-R"]} color={theme["core-06"]}>
        {ScreenText}
      </VDBText>
    </OverLay>
  );
};

const OverLay = styled.View`
  align-items: center;
`;
export default CanRequest;
